import type { ClientMessage } from '@harness/shared/protocol';
import type { TimelineItem } from '../state';
import { ApprovalCard } from './ApprovalCard';
import { ConnectCard } from './ConnectCard';
import { QuestionCard } from './QuestionCard';

type RequestItem = Extract<TimelineItem, { requestId: string }>;

export function RequestCard({ item, send }: { item: RequestItem; send: (message: ClientMessage) => void }): React.JSX.Element {
  switch (item.kind) {
    case 'question':
      return <QuestionCard questions={item.questions} closed={item.closed} onAnswer={(answers) => send({ type: 'answer', requestId: item.requestId, answers })} />;
    case 'approval':
      return (
        <ApprovalCard
          tool={item.tool}
          input={item.input}
          allowTurn={item.allowTurn}
          closed={item.closed}
          onDecide={(allow, scope) => send({ type: 'approval', requestId: item.requestId, allow, scope })}
        />
      );
    case 'connect':
      return <ConnectCard integration={item.integration} url={item.url} closed={item.closed} />;
  }
}
